import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
  FormsModule,
  NgModel,
} from '@angular/forms';
import { Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'; // <-- Import this module

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { basename } from 'path';

import { OnInit, OnDestroy } from '@angular/core';
import { SocketService } from '../services/socket.service';

import {
  debounceTime,
  from,
  Subject,
  Subscription,
  interval,
  takeUntil,
} from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { take } from 'rxjs';
import { ApiServicesService } from '../services/api-services.service';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { SnackbarService } from '../services/snackbar.service';
import { faL } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-login-popup',
  standalone: true,
  imports: [
    MatDialogModule,
    MatTabsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    FormsModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './login-popup.component.html',
  styleUrl: './login-popup.component.css',
})
export class LoginPopupComponent {
  private timerSubscription: Subscription | null = null;
  isForgotPassword = false;
  disablebtn = false;
  minutes: number = 2;
  seconds: number = 0;
  newPwdDisable = false;
  otpdisablebtn = false;
  forgotpwdSubject: Subject<string> = new Subject<string>();
  AuthForm: FormGroup;
  signupForm: FormGroup;
  isOtpVisible: boolean = false;
  showPassword: boolean = false;
  isLoginMode: boolean = true;
  isSubmitting: boolean = false;
  isSubmittingSignup: boolean = false;
  isRequiredError: boolean = false;
  isNewpwdRequiredError: boolean = false;
  isNewpwdTooShortError: boolean = false;
  isNewpwdtoolongError: boolean = false;
  NewpwdcontainsSpecialCharError: boolean = false;
  isRequiredOTP: boolean = false;
  isTooShortError: boolean = false;
  isTooShortOTP: boolean = false;
  istoolongError: boolean = false;
  containsSpecialCharError: boolean = false;
  containsnumber: boolean = false;
  forgotpassword: any;
  timer: any;
  private errorTimer: any;
  timerInterval: any;
  get_OTP: any;
  newpassword: any;
  isTimerRunning: boolean = false;
  countdown: any = '02:00';
  ispwdrest: boolean = false;
  resetpasswordotp: any;
  canResendOtp: boolean = false;
  NewPasswordEmail: any;
  ispwdRequiredError: boolean = false;
  ispwdTooShortError: boolean = false;
  ispwdtoolongError: boolean = false;
  pwdcontainsSpecialCharError: boolean = false;
  newPwddisablebtn: boolean = false;
  isSubmittinggetpassword: boolean = false;
  isSubmittingotp: boolean = false;
  isSubmittingSubmit: boolean = false;
  isonresetRequiredError: boolean = false;
  isonresetTooShortError: boolean = false;
  isonresettoolongError: boolean = false;
  onresetcontainsSpecialCharError: boolean = false;
  onresetdisablebtn: boolean = false;
  authToken: any;
  userEmail: any;
  isloginOtpVisible: any;
  regData: any;
  get selectedIndex(): any {
    return this.isLoginMode ? 0 : 1;
  }
  set selectedIndex(index: any) {
    this.isLoginMode = index === 0;
  }
  genderOptions: any = [];
  usernamePlaceholder: string = 'Username';
  passwordPlaceholder: string = 'Password';
  ignoreDocumentClick = false;
  minBirthYear: number = new Date().getFullYear() - 18;
  birthYears: number[] = Array.from(
    { length: 100 },
    (_, i) => this.minBirthYear - i
  );
    birthMonths = [
      { name: 'January', value: 1 },
      { name: 'February', value: 2 },
      { name: 'March', value: 3 },
      { name: 'April', value: 4 },
      { name: 'May', value: 5 },
      { name: 'June', value: 6 },
      { name: 'July', value: 7 },
      { name: 'August', value: 8 },
      { name: 'September', value: 9 },
      { name: 'October', value: 10 },
      { name: 'November', value: 11 },
      { name: 'December', value: 12 },
    ];
  birthDays: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  @Input() login_popup: boolean = false;
  @Output() showloginpop = new EventEmitter<boolean>(false);
  @Output() isuser = new EventEmitter<boolean>();
  public validatorarray: any = {
    Username: [
      Validators.required,
      Validators.minLength(7),
      Validators.maxLength(50),
      Validators.pattern(
        /^(?!\.)(?!.*\.$)(?!^\d+$)(?=(.*[a-zA-Z]){3,})[a-zA-Z0-9._@]{7,30}$/
      ),
    ],
    Firstname: [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(30),
      Validators.pattern(/^(?!.*\s{2,})[A-Za-z]+(\s[A-Za-z]+)*$/),
    ],
    lastName: [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(30),
      Validators.pattern(/^[A-Za-z]+( [A-Za-z]+)*$/),
    ],
    passwordsignup: [
      Validators.required,
      Validators.minLength(12),
      Validators.maxLength(30),
      Validators.pattern(
        /^(?=(.*[a-z]))(?=(.*[A-Z]))(?=(.*\d))(?=(.*[@$!%*?&#_.\-]))[A-Za-z\d@$!%*?&#_.\-]*$/
      ),
    ],
    confirmPassword: [
      Validators.required,
      Validators.minLength(12),
      Validators.maxLength(30),
      Validators.pattern(
        /^(?=(.*[a-z]))(?=(.*[A-Z]))(?=(.*\d))(?=(.*[@$!%*?&#_.\-]))[A-Za-z\d@$!%*?&#_.\-]*$/
      ),
    ],
    gender: Validators.required,
    email: [
      Validators.required,
      Validators.email,
      Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
    ],
    confirmEmail: [
      Validators.required,
      Validators.email,
      Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
    ],
    username: [
      Validators.required,
      Validators.minLength(7),
      Validators.maxLength(30),
      Validators.pattern(
        /^(?!\.)(?!.*\.$)(?!^\d+$)(?=(.*[a-zA-Z]){3,})[a-zA-Z0-9._@]{7,30}$/
      ),
    ],
    password: [
      Validators.required,
      Validators.minLength(12),
      Validators.maxLength(30),
      Validators.pattern(
        /^(?=(.*[a-z]))(?=(.*[A-Z]))(?=(.*\d))(?=(.*[@$!%*?&#_.\-]))[A-Za-z\d@$!%*?&#_.\-]*$/
      ),
    ],
  };

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    public api: ApiServicesService,
    private snackbarService: SnackbarService,
    private router: Router,
    private socketService: SocketService
  ) {
    this.AuthForm = this.fb.group({
      username: [
        '',
        {
          validators: this.validatorarray['username'],
          updateOn: 'change',
        },
      ],
    });

    this.signupForm = this.fb.group({
      Username: [
        '',
        {
          validators: this.validatorarray['Username'],
          updateOn: 'change',
        },
      ],
      Firstname: [
        '',
        {
          validators: this.validatorarray['Firstname'],
          updateOn: 'change',
        },
      ],
      lastName: [
        '',
        {
          validators: this.validatorarray['lastName'],
          updateOn: 'change',
        },
      ],

      gender: ['Man', Validators.required],
      email: ['', { validators: this.validatorarray['email'] }],
      confirmEmail: ['', { validators: this.validatorarray['confirmEmail'] }],
      birthYear: [this.minBirthYear, Validators.required],
      birthMonth: [1, Validators.required],
      birthDay: [1, Validators.required],
    });
  }

  ngOnInit() {
    this.showloginpop.emit(false);
    this.AuthForm.reset();
    this.signupForm.reset();
    this.isLoginMode = true;
    this.isOtpVisible = false;
    this.isForgotPassword = false;
    this.ispwdrest = false;
    this.selectedIndex = 0;
    const isBrowser = window && typeof window !== 'undefined' && typeof localStorage !== 'undefined';
    if (isBrowser) {
      const encryptedData = localStorage.getItem('encryptedUserData');
      if (!encryptedData) {
        this.login_popup = true;
      }
    }

    this.signupForm
      .get('email')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe(() => {
        this.inputvalid('email');
        this.emailmatchvalidate();
        this.cdr.detectChanges();
      });

    this.signupForm
      .get('confirmEmail')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe(() => {
        this.inputvalid('confirmEmail');
        this.emailmatchvalidate();
        this.cdr.detectChanges();
      });
    this.signupForm
      .get('passwordsignup')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe(() => {
        this.inputvalid('passwordsignup');
        this.pwdmatchvalidate();
        this.cdr.detectChanges();
      });
    this.signupForm
      .get('confirmPassword')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe(() => {
        this.inputvalid('confirmPassword');
        this.pwdmatchvalidate();
        this.cdr.detectChanges();
      });

    this.signupForm
      .get('lastName')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe(() => {
        this.inputvalid('lastName');
        this.cdr.detectChanges();
      });
    this.signupForm
      .get('Firstname')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe(() => {
        this.inputvalid('Firstname');
        this.cdr.detectChanges();
      });
    this.signupForm
      .get('Username')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe(() => {
        this.inputvalid('Username');
        this.cdr.detectChanges();
      });
    this.AuthForm.get('password')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe(() => {
        this.inputvalid('password');
        this.cdr.detectChanges();
      });
    this.AuthForm.get('username')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe(() => {
        this.inputvalid('username');
        this.cdr.detectChanges();
      });

    this.signupForm
      .get('birthMonth')
      ?.valueChanges.subscribe(() => this.updateBirthDays());
    this.signupForm
      .get('birthYear')
      ?.valueChanges.subscribe(() => this.updateBirthDays());
  }

  PasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  startOtpTimer(): void {

    if (this.timer) {
      clearInterval(this.timer);
    }

    this.minutes = 2;
    this.seconds = 0;

    this.isTimerRunning = true;
    this.canResendOtp = false;

    this.updateTimerDisplay();

    this.timer = setInterval(() => {
      if (this.seconds === 0 && this.minutes === 0) {
        this.stopOtpTimer();
        this.canResendOtp = true;
      } else {
        if (this.seconds === 0) {
          this.minutes--;
          this.seconds = 59;
        } else {
          this.seconds--;
        }
      }
      this.updateTimerDisplay();
    }, 1000);
  }

  updateTimerDisplay() {
    this.countdown = `${this.minutes.toString().padStart(2, '0')}:${this.seconds.toString().padStart(2, '0')}`;
  }

  stopOtpTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.isTimerRunning = false;
  }

  tosendOtp(): void {
    const formval = {
      username: this.signupForm.controls['Username'].value,
      gender: this.signupForm.controls['gender'].value,
      first_name: this.signupForm.controls['Firstname'].value,
      last_name: this.signupForm.controls['lastName'].value,
      email: this.signupForm.controls['email'].value ? this.signupForm.controls['email'].value.toLowerCase() : '',
      dob: this.getFormattedDate(),
    };
    this.sendRegOtp(formval);
    this.selectedIndex = '';

  }
  sendOtp() {
    this.api.sendloginOtp(this.userEmail).subscribe(
      (response) => {
        if (response.status == 200) {
          this.startOtpTimer();
          this.snackbarService.openCustomSnackbar({
            icon: true,
            message: 'OTP sent successfully!',
            className: 'success',
          });
          this.isloginOtpVisible = true;
          this.isSubmitting=false;
          setTimeout(() => {
            this.focusFirstInput()  // Call the function after 1 second
          }, 1000);
        }
        else {
          this.isSubmitting=false
          this.startOtpTimer();
          this.snackbarService.openCustomSnackbar({
            icon: false,
            message: response.message,
            className: 'failed',
          });
        }
      },
      (error) => {
        this.isSubmitting=false
        console.error("API Error:", error);
        this.snackbarService.openCustomSnackbar({
          icon: false,
          message: 'Failed to send OTP. Try again.',
          className: 'failed',
        });
      }
    );
    
  }


  loginotp() {
    this.isSubmitting=true;
    this.otpValues = ['', '', '', '', '', ''];
    this.userEmail = this.AuthForm.controls['username'].value;
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.userEmail)) {
    this.userEmail = this.userEmail.toLowerCase();
    }
    this.sendOtp();
    // console.log('convert email',this.userEmail)
  }



  sendRegOtp(formval: any) {
    this.api.sendRegOtp(formval).subscribe(
      (response) => {
        if (response.status == 200) {
          this.isOtpVisible = true;
          this.startOtpTimer();
          this.snackbarService.openCustomSnackbar({
            icon: true,
            message: 'OTP sent successfully!',
            className: 'success',
          });
          setTimeout(() => {
            this.focusFirstInput()  // Call the function after 1 second
          }, 1000);
        } else {
          this.startOtpTimer();
          this.snackbarService.openCustomSnackbar({
            icon: false,
            message: response.message,
            className: 'failed',
          });

        }
      },
      (error) => {
        console.error("API Error:", error);
        this.snackbarService.openCustomSnackbar({
          icon: false,
          message: 'Failed to send OTP. Try again.',
          className: 'failed',
        });
      }
    );

  }


  getvalidationError(value: any): string | null {
    var Control;
    if (value === 'username' || value === 'password') {
      Control = this.AuthForm.controls[value];
    } else {
      Control = this.signupForm.controls[value];
    }

    if (Control.hasError('required')) {
      return 'Please fill out this field';
    }

    if (value === 'Username' || value === 'username') {
      if (Control.hasError('minlength')) {
        return value + '  must be at least 7 characters long.';
      }
    }

    if (value === 'Firstname' || value === 'lastName') {
      if (Control.hasError('minlength')) {
        return value + '  must be at least 3 characters long.';
      }
    }
    if (value === 'email' || value === 'confirmEmail') {
      if (Control.hasError('minlength')) {
        return 'Email must be at least 254 characters long.';
      }
    }
    if (value === 'Username' || value === 'username') {
      if (Control.hasError('pattern')) {
        return 'Username  only contain alphanumeric characters, dots (.), underscores (_), and at signs (@). It cannot start or end with a period, nor consist of only numbers';
      }
    }
    

    if (
      value === 'Username' ||
      value === 'Firstname' ||
      value === 'username' ||
      value === 'lastName'
    ) {
      if (Control.hasError('maxlength')) {
        return value + ' cannot be longer than 30 characters';
      }
    }

    if (value === 'Firstname' || value === 'lastName') {
      if (Control.hasError('pattern')) {
        return value + 'should only contain alphabetic characters. ';
      }
    }

   

    if (value === 'email' || value === 'confirmEmail') {
      if (Control.hasError('email') || Control.hasError('pattern')) {
        return 'Invalid email address';
      } else if (Control.hasError('emailMismatch')) {
        return 'Email mismatch';
      }
    }

  
    return null;
  }


  emailmatchvalidate() {
    const emailval = this.signupForm.controls['email']?.value;
    const confirmEmailval = this.signupForm.controls['confirmEmail']?.value;
    if (emailval && confirmEmailval && emailval != confirmEmailval) {
      this.signupForm.get('email')?.setErrors({ emailMismatch: true });
      this.signupForm.get('confirmEmail')?.setErrors({ emailMismatch: true });
    } else if (emailval && confirmEmailval && emailval == confirmEmailval) {
      this.signupForm.get('email')?.setErrors(null);
      this.signupForm.get('confirmEmail')?.setErrors(null);
    }
  }
  getFormattedDate(): string | null {
    const { birthYear, birthMonth, birthDay } = this.signupForm.value;
    if (birthYear && birthMonth && birthDay) {
      const month = birthMonth.toString().padStart(2, '0');
      const date = birthDay.toString().padStart(2, '0');

      return `${birthYear}-${month}-${date}`;
    }

    return null;
  }
  pwdmatchvalidate() {
    const passwordsignup = this.signupForm.controls['passwordsignup']?.value;
    const confirmPassword = this.signupForm.controls['confirmPassword']?.value;
    if (
      passwordsignup &&
      confirmPassword &&
      passwordsignup != confirmPassword
    ) {
      this.signupForm.get('passwordsignup')?.setErrors({
        passwordMismatch: true,
      });
      this.signupForm.get('confirmPassword')?.setErrors({
        passwordMismatch: true,
      });
    } else if (
      passwordsignup &&
      confirmPassword &&
      passwordsignup == confirmPassword
    ) {
      this.signupForm.get('passwordsignup')?.setErrors(null);
      this.signupForm.get('confirmPassword')?.setErrors(null);
    }
  }
  inputvalid(value: string) {
    var cont;
    if (value === 'username' || value === 'password') {
      cont = this.AuthForm.controls[value];
    } else {
      cont = this.signupForm.controls[value];
    }
    if (cont && (cont.touched || cont.value)) {
      cont.markAsTouched();
    }
  }
  closeDiv(event: Event): void {
    this.AuthForm.reset();
    this.signupForm.reset();
    this.selectedIndex = 0;
    this.login_popup = false;
  }


  onMatSelectOpened(isOpen: boolean): void {
    if (isOpen) {
      this.ignoreDocumentClick = true;
    } else {
      this.ignoreDocumentClick = false;
    }
  }

  closepop(): void {
    this.AuthForm.reset();
    this.signupForm.reset();
    this.selectedIndex = 0;
    this.login_popup = false;
    this.showloginpop.emit(this.login_popup);
  }

  updateBirthDays() {
    const month = parseInt(this.signupForm.get('birthMonth')?.value || '1', 10);
    const year = this.signupForm.get('birthYear')?.value as number;
    const daysInMonth = this.getDaysInMonth(month, year);
    this.birthDays = Array.from({ length: daysInMonth }, (_, i) => i + 1);
  }

  getDaysInMonth(month: number, year: number): number {
    if (month === 2) {
      return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : 28;
    }
    return [4, 6, 9, 11].includes(month) ? 30 : 31;
  }

  loginSubmit(otp: any) {
    this.isSubmittingotp = true;
    this.isSubmitting = true;
    this.userEmail = this.AuthForm.controls['username'].value;
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.userEmail)) {
    this.userEmail = this.userEmail.toLowerCase();
    }
    this.loginUser(this.userEmail, otp);
    // console.log('converted email',this.userEmail)
    
  }
  signupSubmit(otp: any) {
    this.isSubmittingSignup = true;
    const formval = {
      username: this.signupForm.controls['Username'].value,
      gender: this.signupForm.controls['gender'].value,
      first_name: this.signupForm.controls['Firstname'].value,
      last_name: this.signupForm.controls['lastName'].value,
      email: this.signupForm.controls['email'].value,
      dob: this.getFormattedDate(),
      otp: otp
    };
    this.registerUser(formval);
  }
  loginUser(username: any, otp: any) {
    this.api.loginUser(username, otp).subscribe(
      (response) => {
        this.isSubmittingotp = false;
        this.isSubmitting = false;
        if (response.status == 200) {
          this.snackbarService.openCustomSnackbar({
            icon: true,
            message: response.message,
            className: 'success',
          });
          this.userEmail=''
          this.login_popup = false;
          const encryptedData = this.api.encryptData(response);
          localStorage.setItem('encryptedUserData', encryptedData);
          this.showloginpop.emit(false);
          this.isuser.emit(true);
          this.AuthForm.reset();
          this.api.setheaders();
          this.router.navigate(['my-profile', response.user.username, 'Profile']);
          this.backtologin(false);
          this.stopOtpTimer();
          this.otpValues = ['', '', '', '', '', ''];
        } else {
          this.snackbarService.openCustomSnackbar({
            icon: false,
            message: response.message,
            className: 'failed',
          });
          this.otpValues = ['', '', '', '', '', ''];
        }
      },
      (error) => {
        this.isSubmittingotp = false;
        this.isSubmitting = false;
        this.snackbarService.openCustomSnackbar({
          icon: false,
          message: 'Login failed. Please try again.',
          className: 'failed',
        });
      }
    );
  }
  registerUser(value: any) {
    this.api.registerUser(value).subscribe(
      (response) => {
        if (response.status == 200) {
          this.snackbarService.openCustomSnackbar({
            icon: true,
            message: response.message,
            className: 'success',
          });
          this.isSubmittingSignup = false;
          this.login_popup = false;
          const encryptedData = this.api.encryptData(response);

          localStorage.setItem('encryptedUserData', encryptedData);
          this.api.setheaders();
          this.showloginpop.emit(false);
          this.isuser.emit(true);
          this.signupForm.reset();
          this.selectedIndex = 0;
          this.router.navigate(['my-profile', response.user.username, 'Profile']);
          this.stopOtpTimer();
          this.otpValues = ['', '', '', '', '', ''];
        } else {
          this.isSubmittingSignup = false;
          this.snackbarService.openCustomSnackbar({
            icon: false,
            message: response.message,
            className: 'failed',
          });

        }
      },
      (error) => {
        this.isSubmittingSignup = false;
        this.snackbarService.openCustomSnackbar({
          icon: false,
          message: 'Sign-up form is invalid. Please try again.',
          className: 'failed',
        });
      }
    );
  }
  handleInputChange(value: string): void {
    this.forgotpassword = value;
  }



  // getOTP(email: any, value: any) {
  //   // this.ongetOTP();
  //   const otpData = {
  //     email: email,
  //     otp: value,
  //   };

  //   this.api.checkOTP(email, value, 'login').subscribe(

  //     (response) => {
  //       if (response.status == 200) {
  //         this.stopOtpTimer();
  //         this.snackbarService.openCustomSnackbar({
  //           icon: true,
  //           message: 'OTP verified',
  //           className: 'success',
  //         });

  //         const formval = {
  //           username: this.AuthForm.controls['username'].value,
  //         };
  //         this.login_popup = false;
  //         const encryptedData = this.api.encryptData(response);
  //         localStorage.setItem('encryptedUserData', encryptedData);
  //         this.showloginpop.emit(false);
  //         this.isuser.emit(true);
  //         this.AuthForm.reset();
  //         this.api.setheaders();
  //         this.router.navigate(['my-profile', response.user.username, 'Profile']);
  //         this.backtologin(false);
  //       } else {
  //         this.isSubmittingotp = false;
  //         this.snackbarService.openCustomSnackbar({
  //           icon: true,
  //           message: response.message,
  //           className: 'failed',
  //         });
  //       }
  //     },
  //     (error) => {
  //       this.isSubmittingotp = false;
  //       this.isOtpVisible = true;
  //       this.ispwdrest = false;
  //       this.snackbarService.openCustomSnackbar({
  //         icon: false,
  //         message: 'Invalid OTP',
  //         className: 'failed',
  //       });
  //     }
  //   );
  // }


  checkRegOTP(email: any, value: any) {
    // this.ongetOTP();
    const otpData = {
      email: email,
      otp: value,
    };

    this.api.checkOTP(email, value, 'register').subscribe(

      (response) => {
        if (response.status == 200) {
          this.stopOtpTimer();
          this.snackbarService.openCustomSnackbar({
            icon: true,
            message: 'OTP verified',
            className: 'success',
          });

          const formval = {
            username: this.AuthForm.controls['username'].value,
          };
          // this.loginUser(this.AuthForm.value);
        } else {
          this.isSubmittingotp = false;
          this.snackbarService.openCustomSnackbar({
            icon: false,
            message: response.message,
            className: 'failed',
          });
        }
      },
      (error) => {
        this.isSubmittingotp = false;
        this.isOtpVisible = true;
        this.ispwdrest = false;
        this.snackbarService.openCustomSnackbar({
          icon: false,
          message: 'Invalid OTP',
          className: 'failed',
        });
      }
    );
  }

  newPwd(value: any) {
    const otpData = {
      email: this.NewPasswordEmail,
      otp: value,
    };

    this.api.newpassword(this.NewPasswordEmail, value).subscribe(
      (response) => {
        this.snackbarService.openCustomSnackbar({
          icon: true,
          message: 'Password updated successfully!',
          className: 'success',
        });
        this.isSubmittingSubmit = false;
        this.ispwdrest = false;
        this.login_popup = true;
        this.isOtpVisible = false;
        this.newpassword = "";
        this.isNewpwdRequiredError = false;
        this.isNewpwdTooShortError = false;
        this.isNewpwdtoolongError = false;
        this.NewpwdcontainsSpecialCharError = false;
      },
      (error) => {
        console.error('Error:', error);
        this.isSubmittingSubmit = false;
        this.isOtpVisible = false;
        this.ispwdrest = true;
        this.snackbarService.openCustomSnackbar({
          icon: false,
          message: 'Invalid password',
          className: 'failed',
        });
      }
    );
  }

  // onEnterKey(event: Event): void {
  //   event.preventDefault();
  //   this.onForgotPasswordChange();
  //   if (this.disablebtn) {
  //     this.forgotpwd();
  //   }
  // }

  // forgotpwd(): void {
  //   this.isSubmittinggetpassword = true;
  //   const forgotEmail = this.forgotpassword;
  //   this.get_OTP = "";
  //   this.isRequiredOTP = false;
  //   this.containsnumber = false;
  //   this.otpdisablebtn = false;
  //   this.getforgotpwd(forgotEmail);
  // }

  // resetpassword(): void {
  //   if (this.get_OTP) {
  //     this.isSubmittingotp = true;
  //     const reset = this.get_OTP;
  //     this.getOTP(reset);
  //   }
  // }

  onGetPassword(): void {
    if (this.newpassword) {
      this.isSubmittingSubmit = true
      const reset = this.newpassword;
      this.newPwd(reset);
    }
  }

  backtologin(showForgotPassword: boolean) {
    // this.isForgotPassword = showForgotPassword;
    // this.isOtpVisible = false;
    // this.isRequiredError = false;
    // this.isTooShortError = false;
    // this.istoolongError = false;
    // this.disablebtn = false;
    // this.containsSpecialCharError = false;
    // if (!showForgotPassword) {
    //   this.AuthForm.reset();
    //   this.NewPasswordEmail = "";
    //   this.forgotpassword = "";
    //   this.newpassword = "";
    //   this.resetpasswordotp = "";
    //   this.get_OTP = "";
    //   this.isLoginMode = true;
    //   this.isRequiredOTP = false;
    //   this.containsnumber = false;
    // }
    this.isloginOtpVisible = false;
  }


  backtoregister(showForgotPassword: boolean) {

    this.isOtpVisible = false;
  }

  changepwd() {
    this.disablebtn = false;
    this.isForgotPassword = true;
    this.isOtpVisible = false;
    this.forgotpassword = '';
    this.isOtpVisible = false;
    this.isRequiredError = false;
    this.isTooShortError = false;
    this.istoolongError = false;
    this.disablebtn = false;
    this.get_OTP = "";
    this.isRequiredOTP = false;
    this.containsnumber = false;
    this.stopOtpTimer();
  }

  onTabchange(event: any): void {

    if (!this.isTimerRunning) {
      this.isLoginMode = event.index == 0 ? true : false;
      if (event.index === 0) {
        this.AuthForm.reset();
        this.isForgotPassword = false;
        this.isOtpVisible = false;
        this.ispwdrest = false;
        this.NewPasswordEmail = "";
        this.forgotpassword = "";
        this.newpassword = "";
        this.resetpasswordotp = "";
        this.get_OTP = "";

      } else if (event.index === 1) {
        if (this.genderOptions == '') {
          this.api.getGenders().subscribe((response) => {
            this.genderOptions = response?.data || [];
            if (this.genderOptions.length > 0) {
              const defaultGender = this.genderOptions[0]?._id;
              this.signupForm.get('gender')?.setValue(defaultGender);
            }
          });
        }
        this.signupForm.reset();
        this.signupForm.controls['birthMonth'].setValue(1);
        this.signupForm.controls['birthYear'].setValue(this.minBirthYear);
        this.signupForm.controls['birthDay'].setValue(1);
        this.signupForm.controls['gender'].setValue(this.genderOptions[0]?._id);
        this.signupForm.updateValueAndValidity();
      }
      this.isloginOtpVisible=false;
      this.isOtpVisible=false;
    }


    if (event.index === 1) {
      if (this.genderOptions == '') {
        this.api.getGenders().subscribe((response) => {
          this.genderOptions = response?.data || [];
          if (this.genderOptions.length > 0) {
            const defaultGender = this.genderOptions[0]?._id;
            this.signupForm.get('gender')?.setValue(defaultGender);
          }
        });
      }
    }

    
  }

  // ----------------------otp-----------------


  otpValues: string[] = ['', '', '', '', '', '']; // Array to hold each OTP digit
  otpFields: number[] = Array(6).fill(0); // Creates 6 fields
  isSubmittingotp1 = false;

  @ViewChild('firstInput') firstInput!: ElementRef<HTMLInputElement>;

  focusFirstInput(): void {
    if (this.firstInput && this.firstInput.nativeElement) {
      this.firstInput.nativeElement.focus(); // Set focus on the first input field
    }
  }

  // Function triggered on OTP input
  onOtpInput(event: any, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Check if the input is a digit
    if (/^\d$/.test(value)) {
      this.otpValues[index] = value; // Save the valid digit
      // Move to the next field if a valid digit is entered
      if (index < 5) {
        const nextInput = input.nextElementSibling as HTMLInputElement;
        if (nextInput) nextInput.focus();
      }
    } else {
      // If the input is not a digit, clear the input field
      input.value = '';
      this.otpValues[index] = '';
    }
  }

  onOtpKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace' && index > 0 && !this.otpValues[index]) {
      const prevInput = (event.target as HTMLInputElement).previousElementSibling as HTMLInputElement;
      if (prevInput) prevInput.focus();
    }
  }

  getCombinedOtp(): string {
    return this.otpValues.join('');
  }

  isOtpComplete(): boolean {
    return this.otpValues.every(value => value !== '');
  }

  // Verify OTP logic
  verifyOtp(): void {
    if (this.isOtpComplete()) {
      const otp = this.getCombinedOtp();
      // console.log('OTP Entered:', otp);
      this.loginSubmit(otp)
    } else {
      console.error('All OTP fields must be filled.');
    }
  }


  verifyRegOtp(): void {
    if (this.isOtpComplete()) {
      const otp = this.getCombinedOtp();
      // console.log('OTP Entered:', otp);
      this.signupSubmit(otp)
    } else {
      console.error('All OTP fields must be filled.');
    }
  }






  onOtpPaste(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent default paste behavior
  
    const pastedData = event.clipboardData?.getData('text') || '';
    const digits = pastedData.replace(/\D/g, '').split(''); // Extract only digits
  
    if (digits.length > 0) {
      const otpInputs = document.querySelectorAll('.otp-input') as NodeListOf<HTMLInputElement>;
  
      // Find the index of the currently focused input
      const focusedInput = event.target as HTMLInputElement;
      const startIndex = Array.from(otpInputs).indexOf(focusedInput);
  
      // If the focused input is valid, start pasting from there
      if (startIndex !== -1) {
        digits.forEach((digit, index) => {
          if (startIndex + index < 6) {
            this.otpValues[startIndex + index] = digit;
          }
        });
  
        // Focus on the next empty field or the last field
        const nextEmptyIndex = this.otpValues.findIndex((value, idx) => value === '' && idx >= startIndex);
        const nextInput = otpInputs[nextEmptyIndex] || otpInputs[5]; // Default to the last field if no empty field
  
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  }

  onOtpEnter(): void {
    if (this.isOtpComplete()) {
      this.sendOtp(); // Call sendOtp() if all fields are filled
    }
  }


  onRegEnter(): void {
    if (this.isOtpComplete()) {
      this.tosendOtp(); // Call sendOtp() if all fields are filled
    }
  }



}
